module.exports = __webpack_public_path__ + "static/image/history/m/202010@3x.ver2_0_2.jpg?ef0d1b3c";